'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import { distribute } from '../_support'
import Box, { BoxProps } from '../box'
import Text, { TextProps } from '../text'

/* -----------------------------------------------------------------------------
 * Alert
 * -------------------------------------------------------------------------- */

export type AlertTypes = 'error'

export type AlertProps = TextProps &
  BoxProps & {
    type?: AlertTypes
  }

const Alert = ({ children, type = 'error', ...rest }: AlertProps) => {
  const [boxProps, textProps] = distribute(rest, {
    using: Box.styleKeys,
    to: {},
    rest: {}
  })

  const { box: boxTypeProps, text: textTypeProps } = (
    {
      error: {
        box: { bg: 'paleError' },
        text: { textColor: 'error', variant: 'small' }
      }
    } as const
  )[type]

  return (
    <Box py='08' px='12' borderRadius='small' {...boxTypeProps} {...boxProps}>
      <Text {...textTypeProps} {...textProps}>
        {children}
      </Text>
    </Box>
  )
}

export default Alert
